// React
import React from 'react';
import { useTranslation } from 'react-i18next';

// Material
import { Grid, CircularProgress, Typography } from '@material-ui/core';

// CSS
import useStyles from './styles';

const ChatVideoLogLoadingBlock: React.FC = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <Grid container className={classes.container} direction="column">
      <Grid
        className={classes.loadingText}
        container
        item
        spacing={2}
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Grid item>
          <CircularProgress color="secondary" />
        </Grid>

        <Grid item>
          <Typography variant="h6" color="primary">
            {translate('page.video.pleaseWait')}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChatVideoLogLoadingBlock;
